import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { alpha } from "@mui/material/styles";
import RefreshIcon from "@mui/icons-material/Refresh";
import NoticeboardButton from "./NoticeboardButton";

export interface ErrorStateProps {
  title: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
  buttonText?: string;
  onRetry?: () => void;
  /** Fills parent area (e.g. calendar grid) when set */
  minHeight?: number | string;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  title,
  description,
  imageSrc,
  imageAlt,
  buttonText = "Try again",
  onRetry,
  minHeight,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: 4, sm: 6 },
        ...(minHeight != null ? { minHeight } : {}),
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          maxWidth: 420,
          width: "100%",
        }}
      >
        <Box
          sx={{
            width: 140,
            height: 140,
            borderRadius: "50%",
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
          }}
        >
          <Box
            component="img"
            src={imageSrc}
            alt={imageAlt}
            sx={{
              width: 100,
              height: 100,
              objectFit: "contain",
            }}
          />
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 500,
            color: "text.primary",
            mb: 1,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            lineHeight: 1.6,
            mb: onRetry ? 3 : 0,
          }}
        >
          {description}
        </Typography>
        {onRetry && (
          <NoticeboardButton
            variant="primary"
            onClick={onRetry}
            startIcon={<RefreshIcon />}
            sx={{
              py: 1.25,
              px: 3,
              fontWeight: 400,
            }}
          >
            {buttonText}
          </NoticeboardButton>
        )}
      </Box>
    </Paper>
  );
};

export default ErrorState;
